export default {
  form: {
    country: {
      label: 'Land',
      placeholder: 'Selecteer land',
    },
  },
};
